import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Fragment, useState } from "react";
import { styled } from "../theme";
import { ProgressBar } from "./atoms/ProgressBar";
import { GroupRow } from "./atoms/GroupRow";
import { SectionRow } from "./atoms/SectionRow";
import { SlideRow } from "./atoms/SlideRow";
import { TableOfContentsHeader } from "./atoms/TableOfContentsHeader";
import { ToggleCheckbox } from "./atoms/ToggleCheckbox";
export const TableOfContentRenderer = ({ fullTOC, incompleteSlides, showIncompleteSlidesOnly, onToggleIncomplete, slideIndex, onSlideClick, hasExpandedBlocks, }) => {
    const [expandedBlockIds, setExpandedBlockIds] = useState([]);
    const toggleBlock = (id) => {
        if (expandedBlockIds.includes(id)) {
            setExpandedBlockIds(state => state.filter(storedId => storedId !== id));
        }
        else {
            setExpandedBlockIds(state => state.concat(id));
        }
    };
    const getActiveSlideIndex = (id, slideIndexes) => slideIndexes.find(itemId => itemId >= id);
    const extractSlideIndexes = (groups) => {
        return groups.reduce((ids, group) => ids.concat(group.children.map(section => section.children.map(slide => slide.idx))), []);
    };
    const renderTable = (toc) => {
        const slideIndexes = extractSlideIndexes(toc.groups);
        const activeSlideId = getActiveSlideIndex(slideIndex, slideIndexes);
        return toc.groups.map(group => {
            const isExpanded = hasExpandedBlocks || expandedBlockIds.includes(group.id);
            return (group.state.totalSlides > 0 && (_jsxs(GroupItem, { children: [_jsx(GroupRow, { data: group, expanded: isExpanded, onClick: toggleBlock }), isExpanded &&
                        group.children.map(section => (_jsxs(Fragment, { children: [section.children.length > 0 && (_jsx(SectionRow, { translationKey: section.title.translationKey })), section.children.map(slide => (_jsx(Fragment, { children: _jsx(SlideRow, { index: slide.idx, onClick: onSlideClick, translationKey: slide.title.translationKey, hasFlags: slide.state.totalFlags > 0, active: slide.idx === activeSlideId }) }, slide.id)))] }, section.id)))] }, group.id)));
        });
    };
    const toc = showIncompleteSlidesOnly ? incompleteSlides : fullTOC;
    const { totalSlides, completedSlides } = fullTOC.state;
    return (_jsxs(_Fragment, { children: [_jsx(ToggleCheckbox, { checked: showIncompleteSlidesOnly, onCheck: onToggleIncomplete }), _jsx(ProgressBar, { total: totalSlides, completed: completedSlides, progress: calculateAdmissionProgress(totalSlides, completedSlides) }), _jsx(TableOfContentsHeader, {}), renderTable(toc)] }));
};
const calculateAdmissionProgress = (total, completed) => total === 0 ? 100 : Math.round((completed / total) * 100);
const GroupItem = styled.div `
  border-bottom: 1px solid ${({ theme }) => theme.color.borderGray};
`;
